module.exports = __webpack_public_path__ + "static/31-b674ca6eb32aa8bcbdba79c9c458282b.png";